import { render, staticRenderFns } from "./DashboardGraphModule.vue?vue&type=template&id=0875aa8b&scoped=true"
import script from "./DashboardGraphModule.vue?vue&type=script&lang=js"
export * from "./DashboardGraphModule.vue?vue&type=script&lang=js"
import style0 from "./DashboardGraphModule.vue?vue&type=style&index=0&id=0875aa8b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0875aa8b",
  null
  
)

export default component.exports